var parent = require('../../es/array/is-array');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/array/is-array.js
// module id = 542
// module chunks = 0 1